module.exports = __webpack_public_path__ + "static/media/you-won.a1a0f624.png";